/**
 * Created by bob.gear on 21/03/2015.
 */
/*
 *  This is the plan
 *
 *  All the Mechanics of creating a query definition will be enclosed in
 *  a new module (QueryBuilder). This will include any necessary directives,
 *  templates, etc.
 *
 *  The idea is that  the QueryBuilder will be given a QueryDefinition to
 *  work on (often a new on) and that  the output will be a ready to run
 *  queryDefinition.
 *
 *  Since this is a major refactor, the QueryBuilder module will be built
 *  side-by-side. there needs to be a feature switch to enable one
 *  implementation or the other (by choosing which files to load?).
 *
 */

var EICDataStream3QueryBuilder = angular.module("EICDataStream3.queryBuilder", ["EICDataStream3.resources", "EICDataStream3.directives", "EICDataStream3.domUtilities", "EICDataStream3.checkboxList", "EICDataStream3.userData"])
  .config(function () {
  });


//------------------------------------------------------------------------
//  searchFilter Directive
//  Common container for all search filters
//------------------------------------------------------------------------
EICDataStream3QueryBuilder
  .controller('searchFilterController', ['$scope',
    function ($scope) {
    }])
  .directive('searchFilter', ['$compile', '$timeout',
    function ($compile, $timeout) {
      return {
        scope: {
          criteria: '=',
          state: '='
        },
        replace: true,      // replace the placeholder element with the template
        restrict: 'A',   // usage: <div projectNameFilter />
        templateUrl: "../app-ds3/search/queryBuilder/searchFilterContainer.tmpl.html",
        // class='btn btn-info fixed-btn' style='margin-top:1px;'
        link: function postLink($scope, iElement, iAttrs) {
          // compose and compile the content into the frame
          var filterDirective = iAttrs.searchFilter;
          iElement.attr("id", camelCase(iAttrs.searchFilter));

          // get the target filter and compile its template
          var elementHtml = "<div ~filterDirectiveName~='' />".replace("~filterDirectiveName~", filterDirective);

          var a_input = angular.element($compile(elementHtml)($scope));
          iElement.find("#insertPoint").replaceWith(a_input);


          function camelCase(str) {
            return str.replace(/\W+(.)/g, function (x, chr) {
              return chr.toUpperCase();
            })
          }


        },

        controller: 'searchFilterController'
      }
    }]);
//------------------------------------------------------------------------

//------------------------------------------------------------------------
//  eicSearchFilters Directive
//------------------------------------------------------------------------
// The controller is implemented separately  from the directive so that
// it is easier to  unit test
//
// When the search button is pressed, the directive broadcasts NEW_SEARCH
// This event can be intercepted in other parts function the app to  ensure
// that specific actions occur

//------------------------------------------------------------------------
EICDataStream3QueryBuilder
  .directive('queryBuilder', ['$compile', 'searchService', '$animate', 'queryBuilderService',
    function ($compile, searchService, $animate, queryBuilderService) {
      return {
        replace: true,
        restrict: 'A',
        // transclude: true,

        templateUrl: "../app-ds3/search/queryBuilder/queryBuilder.partial.html",


        /**
         * When items are added to the added filters collection,
         * the requested template needs to be loaded, cmpiles and
         * inserted into the DOM so that eh filter is activated
         *
         * Each Filter has a common surround that is provided by the
         * search-filter directive. The primary argument is the name
         * of the filter to  load. The search-filter directive uses this
         * to load and xompile the filter itself into the
         * surround.
         *
         * Each filter is given the filtername as its id. this id is used
         * when the filter is removed
         *
         * Each filter exists in an isolated scope that  is provided by
         * the instance of the search filter container.
         */
        link: function ($scope, iElement, iAttrs) {
          $scope.$watch('queryBuilderService.addedFilters', function () {
            for (var i = 0; i < queryBuilderService.addedFilters.length; i++) {
              var filterName = queryBuilderService.addedFilters[i];

              // derive the full html using the filter name...
              var html = getCompilableFilter(filterName);

              // compile the html to  give a full jquery element
              var el = angular.element($compile(html)($scope));

              // append the new filter element to  the filters node
              iElement.find("#filters").append(el);
            }
            queryBuilderService.addedFilters.length = 0;
          }, true);


          var getCompilableFilter = function (filterName) {
            var snakedFilterName = snake_case(filterName, "-");
            var element = "<div search-filter='~snakedFilterName~' criteria='searchService.queryDef.criteria' state='queryBuilderService.state'  />";

            return element.replace("~snakedFilterName~", snakedFilterName);
          };

          // todo: find out how to access a library function instead of having a copied definition here
          var SNAKE_CASE_REGEXP = /[A-Z]/g;
          var snake_case = function (name, separator) {
            separator = separator || '_';
            return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
              return (pos ? separator : '') + letter.toLowerCase();
            });
          };

        },

        controller: 'queryBuilderController'
      };

    }]);


EICDataStream3QueryBuilder
  .controller('queryBuilderController',
    ['$scope', '$rootScope', '$state', '$timeout', '$http', 'searchService', 'projectDataService', 'contractDataService', 'savedSearches', 'savedSearchListItems', 'lastSearch', 'queryBuilderService', 'FEATURE_SWITCHES', 'userAccessService',
      function ($scope, $rootScope, $state, $timeout, $http, searchService, projectDataService, contractDataService, savedSearches, savedSearchListItems, lastSearch, queryBuilderService, FEATURE_SWITCHES, userAccessService) {

        $scope.componentName = "queryBuilderController - eicSearchFilters";

        $scope.isMobile = window.innerWidth < 825;

        $scope.projectDataService = projectDataService;
        $scope.contractDataService = contractDataService;
        $scope.searchService = searchService;
        $scope.queryBuilderService = queryBuilderService;


        $scope.projectNameChanged = function () {
          var i = 0;
        };

        $scope.multiple = false;

        $scope.nullSavedSearchListItem = { value: '00000000-0000-0000-0000-000000000000', label: '', searchName: '' };


        $scope.$on("DETAIL_PAGE_ACTIVATED", function (event, isDetailPage) {
          $scope.hideQuerySpecificationControl = isDetailPage;
        });




        // The presence of this line makes a returning contract award search show
        // the list of project filters
        //  searchService.queryDef.searchSubject = "Project";
        $scope.searchName = {};
        $scope.selectedFilters = [];


        $scope.removeFilter = function (filterName) {
          $(filterName).slideUp('fast', function () {
            $scope.$apply(function () {

              // remove the filter element from the DOM
              $(filterName).remove(filterName);

              // throw away the leading # character and remove the
              // filter name from the list of selected filters
              filterName = filterName.substring(1, filterName.length);
              searchService.queryDef.searchFilters.splice($.inArray(filterName, searchService.queryDef.searchFilters), 1);
            });
          });
        };


        $scope.removeAllFilters = function (whenDone) {

          // remove the entire contents of the #filters container in the DOM
          // then execute the passedin function
          $("#filters").empty();

          if (whenDone) whenDone();
        };


        $scope.getSavedQueries = function () {
          $scope.savedQueries = savedSearchListItems.query(function () {
            $scope.selectedQuery = $scope.nullSavedSearchListItem;
          });
        };


        $scope.getSavedQueries();


        $scope.newProjectSearch = function () {
          queryBuilderService.state.toCreating();
          Placeholders.enable();

          searchService.queryDef.searchSubject = "Project";
          searchService.queryDef.sorting.sort_order = 'ProjectName';
          searchService.queryDef.sorting.sort_desc = false;

        };


        $scope.newOperatingCompanySearch = function () {

        };


        $scope.newContractAwardSearch = function () {
          queryBuilderService.state.toCreating();
          Placeholders.enable();

          searchService.queryDef.searchSubject = "Contract Award";
          searchService.queryDef.sorting.sort_order = 'DollarValue';
          //searchService.queryDef.sorting.sort_order = 'ShortContractType';
          searchService.queryDef.sorting.sort_desc = true;

        };



        $scope.btnSearch = function () {
          searchService.fromSearchButtonPress = true;
          searchService.queryDef.paging.offset = 0;

          var displaySearchName = "";
          $scope.$broadcast("NEW_SEARCH");

          ////////////////////////////////////////////////////////
          // Upsert the saved search definition
          ////////////////////////////////////////////////////////
          // if the queryDef contains a guid, update the definition
          // otherwise, create a new saved search and fill in its guid
          if (searchService.queryDef.guid) {
            savedSearches.update(searchService.queryDef,
              function (p) {
                if (searchService.queryDef.searchName) {
                  displaySearchName = p.searchName.urlEncode();
                  // transition to a new state; this updates the route,
                  // loads the controller and and triggers the search
                  updateSavedSearchListItem(p);

                  queryBuilderService.state.toDisplaying();
                }
                else {
                  queryBuilderService.state.toCreating();
                }

                if (!$scope.filtersPinned) {
                  $scope.showFilterContainer = false;
                }

                var substate = (p.searchSubject + " Summary").toCamelCase();
                $state.go("search." + substate, { guid: p.guid, name: displaySearchName });
              }, updateSearchDefinitionFailed
            );
          }
          else {
            savedSearches.create(searchService.queryDef,
              function (p) {
                if (searchService.queryDef.searchName) {
                  displaySearchName = p.searchName.urlEncode();
                  addSavedSearchListItem(p);
                  //$scope.searchName.message = "The search definition was successfully saved.";
                  $scope.searchName.messageClass = "";
                  $timeout(function () { $scope.searchName.message = ""; }, 5000);
                }

                queryBuilderService.state.toCreating();

                if (!$scope.filtersPinned) {
                  $scope.showFilterContainer = false;
                }

                // transition to a new state; this updates the route,
                // loads the controller and and triggers the search
                var substate = (p.searchSubject + " Summary").toCamelCase();
                $state.go("search." + substate, { guid: p.guid, name: displaySearchName });
              }, createSearchDefinitionFailed
            );

          }

        };


        var createSearchDefinitionFailed = function () {
          $scope.searchName.message = 'There was an error and the search definition was not created';
          $scope.searchName.messageClass = 'error';

          $scope.showFilterContainer = true;

          $timeout(function () {
            $scope.searchName.message = "";
          }, 10000);
        };


        var updateSearchDefinitionFailed = function () {
          $scope.searchName.message = 'There was an error and the search definition was not updated';
          $scope.searchName.messageClass = 'error';

          $timeout(function () {
            $scope.searchName.message = "";
          }, 10000);
        };


        var addSavedSearchListItem = function (p) {
          var s = {};
          s.value = p.guid;
          s.label = p.searchName;
          s.searchSubject = p.searchSubject;

          $scope.savedQueries.push(s);
          $scope.savedQueries.sort(sortSavedSearchItemsByLabel);

          $scope.searchName.message = "The search definition was successfully saved.";
          $scope.searchName.messageClass = "";
          $timeout(function () { $scope.searchName.message = ""; }, 5000);

        };


        var updateSavedSearchListItem = function (li) {
          // in $scope.savedQueries, find the item with
          // a matching searchGuid and update its searchName
          for (var i = 0; i < $scope.savedQueries.length; i++) {
            if ($scope.savedQueries[i].value == li.guid) {
              $scope.savedQueries[i].label = li.searchName;
              break;
            }
          }
          $scope.savedQueries.sort(sortSavedSearchItemsByLabel);
        };


        var deleteSearchFailed = function (p) {
          $scope.searchName.message = 'There was an error and the search definition was not deleted';
          $scope.searchName.messageClass = 'warning';

          $timeout(function () { $scope.searchName.message = ""; }, 5000);
        };


        var sortSavedSearchItemsByLabel = function (a, b) {
          var labelA = a.label.toLowerCase(), labelB = b.label.toLowerCase();
          if (labelA < labelB) return -1;
          if (labelA > labelB) return 1;
          return 0;
        };


        $scope.btnRepeatLastSearch = function () {
          var currentSearchGuid = searchService.queryDef.guid || null;
          var lastSearchSpec = lastSearch.get({ currentSearchGuid: currentSearchGuid }, function () {
            var newState = "search." + (lastSearchSpec.searchSubject + ' Summary').toCamelCase();
            if (lastSearchSpec.searchName) {
              $state.go(newState, { guid: lastSearchSpec.guid, name: lastSearchSpec.searchName.urlEncode() });
            }
            else {
              $state.go(newState, { guid: lastSearchSpec.guid, name: "" });
            }
          });



        };


        $scope.selectQuery = function (selectedQuery) {
          $scope.selectedQuery = selectedQuery;
        };


        $scope.btnDeleteQuery = function (guid) {
          // call api to delete the selected query
          // on success, remove the entry from the dropdown
          // (note: delete is now a reserved word and as such, will cause and
          // exception in IE8 and will break MVC4 minification, so  use
          // ['delete'] syntax instead
          savedSearches.delete({ guid: guid }, function () {
            var searchName = removeSavedSearchListItem(guid);

            $scope.btnNewSearch();

            $scope.searchName.message = "Search '" + searchName + "' was successfully deleted.";
            $scope.searchName.messageClass = "";
            $timeout(function () { $scope.searchName.message = ""; }, 5000);

          }, deleteSearchFailed);

        };


        var removeSavedSearchListItem = function (searchGuid) {
          for (var i = $scope.savedQueries.length - 1; i >= 0; i--) {
            if ($scope.savedQueries[i].value === searchGuid) {
              var searchName = $scope.savedQueries[i].label;
              $scope.savedQueries.splice(i, 1);
              return searchName;
            }
          }

        };

        $scope.btnExport = function (guid) {
          $http.get('/api/summaryexport/' + searchService.queryDef.guid,
            { 'Content-Type': 'application/json' })
            //      var response = $http.post('/api/projectcount/',,
            //      {
            //        'Content-Type'
            //      :
            //        'application/json'
            //      }
            //          searchService.queryDef)
            //          .success(success)
            .catch(function (err) {
              var i = 0;
            });
        };

        $scope.$watch('selectedQuery', function () {
          // guard conditions to  ensure that the selected query is
          // a real saved search entry
          if (!$scope.selectedQuery) return;
          if (!$scope.selectedQuery.searchSubject) return;

          // if the selected query exists, load it and put the filters in the displaying state
          queryBuilderService.state.toDisplaying();

          // if the selected query guid changes, then the new saved search needs to be loaded using the api
          // this is achieved by transitioning to a new state using the info in the selected query entry
          // The transition is detected by the Filter Directives watcher on the search guid so that  the
          // active filters and  display state can be updated
          var substate = ($scope.selectedQuery.searchSubject + " Summary").toCamelCase();
          $state.go("search." + substate, { guid: $scope.selectedQuery.value, name: $scope.selectedQuery.label.urlEncode() });

        }, true);


        $scope.$watch('searchService.queryDef.guid', function (newVal, oldVal) {
          // if there never was a search guid, there is no need to clear the filters.
          // In fact, doing so is harmful because it prevents us from setting and changing
          // default values properly.
          // if (!oldVal && !queryBuilderService.state.isStarting) {
          //    queryBuilderService.state.toCreating();
          //   return;
          // }

          if (searchService.queryDef.searchName) {
            $scope.removeAllFilters(queryBuilderService.reinstateFilterList);
            queryBuilderService.state.toDisplaying();
          }
          else {
            if (searchService.queryDef.guid) {
              $scope.removeAllFilters(queryBuilderService.reinstateFilterList);
              queryBuilderService.state.toCreating();
            }
            else {
              $scope.removeAllFilters();
              if (!queryBuilderService.state.isStarting) queryBuilderService.state.toSelectingSubject();
            }
          }

        });


        $scope.$watch('searchService.queryDef.searchSubject', function () {
          if (!searchService || !searchService.queryDef) return;

          if (searchService.availableFilters) searchService.availableFilters.length = 0;
          else searchService.availableFilters = [];

          if (searchService.queryDef.searchSubject === 'Project') {
            searchService.availableFilters = searchService.availableFilters.concat(projectFilterList);
            userAccessService.getRights()
              .then(function (response) {
                var access = response.data;

                if (access.accessType === 'industry') {
                  searchService.availableFilters = searchService.availableFilters.map(function (item) {
                    if (item.divider) {
                      // return the divider unchanged
                      return item;
                    }

                    item.hidden = !(access.allowedSectors.some(function (v) {
                      return item.validForSectors.indexOf(v) >= 1;
                    }));

                    //item.hidden = !(item.validForSectors.some(function(v) {
                    //  return access.allowedSectors.indexOf(v) >= 1;
                    //}));

                    return item;
                  });
                }
              });

          }
          else if (searchService.queryDef.searchSubject == 'Contract Award') {
            searchService.availableFilters = searchService.availableFilters.concat(contractAwardFilterList);
          }
        });

        $scope.multipleToggle_clicked = function (multiple) {
          if ($scope.multiple) $scope.selectedFilters.length = 0;

          $scope.multiple = multiple;
          $scope.filterPlural = multiple ? "s" : "";
        };

        $scope.addFilter = function (index) {
          var filter = searchService.availableFilters[index];

          if (!queryBuilderService.state.isEditing) queryBuilderService.state.toCreating();

          if (searchService.queryDef.searchFilters.indexOf(filter.name) == -1) {
            searchService.queryDef.searchFilters.push(filter.name);
            queryBuilderService.addedFilters.push(filter.name);
          }
        };


        $scope.addFilters = function (selectedFilters) {
          if (angular.isArray(selectedFilters)) {
            selectedFilters.map(function (filter) {
              $scope.addFilter(filter.index);
            });
            selectedFilters.length = 0;
          }
          else {
            $scope.addFilter(selectedFilters.index);
            selectedFilters = [];
          }

        };


        var filterindex = 0;
        var projectFilterList = [
          {
            index: filterindex++,
            text: "Project Name",
            name: "projectNameFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Project Value",
            name: "projectValueFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Terrain",
            name: "projectTerrainFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Industry Sector/Project Type",
            name: "industrySectorsFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          //{
          //  text:        "Project Type",
          //  name:        "projectTypesFilter",
          //  click:       "addFilter("  + filterindex++ + ");",
          //  enabled:     false,
          //  implemented: false
          //},
          {
            index: filterindex++,
            text: "Project Location",
            name: "projectLocationFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Project Stage",
            name: "projectStagesFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Project Status",
            name: "projectStatusesFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Start-up Year",
            name: "startupYearFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "FID Date",
            name: "fidDateFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Free Text",
            name: "fullTextFilter",
            disabled: !FEATURE_SWITCHES.FREE_TEXT_FILTER.enabled,
            hidden: !FEATURE_SWITCHES.FREE_TEXT_FILTER.implemented,
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Equipment Types",
            name: "equipmentTypeFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Pipelines",
            name: "pipelinesFilter",
            validForSectors: [1, 2, 3, 4, 5, 7]
          },
          {
            index: filterindex++,
            text: "Power Output (MW)",
            name: "powerOutputFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Operators",
            name: "operatorsFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Wind Turbine Manufacturers",
            name: "windTurbineManufacturersFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Offshore Wind Foundation Types",
            name: "offshoreWindFoundationTypeFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Water Depth",
            name: "waterDepthFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            divider: true,
            text: "contracting",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Contractors (old)",
            name: "contractorsFilter",
            disabled: true,
            hidden: true,
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Contractors",
            name: "contractorsHierachyFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            text: "Contract Stage",
            name: "contractStageFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          },
          {
            index: filterindex++,
            divider: true,
            text: ""
          },
          {
            index: filterindex++,
            text: "Project Created",
            name: "projectCreatedDateFilter",
            validForSectors: [1, 2, 3, 4, 5, 6, 7, 8]
          }
        ];


        // var filterindex=0;
        //       var projectFilterListOld = [
        //         {
        //           text: "Project Name",
        //           name: "projectNameFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Project Value",
        //           name: "projectValueFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Terrain",
        //           name: "projectTerrainFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Industry Sector/Project Type",
        //           name: "industrySectorsFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         //{
        //         //  text:        "Project Type",
        //         //  name:        "projectTypesFilter",
        //         //  click:       "addFilter("  + filterindex++ + ");",
        //         //  enabled:     false,
        //         //  implemented: false
        //         //},
        //         {
        //           text: "Project Location",
        //           name: "projectLocationFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Project Stage",
        //           name: "projectStagesFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Project Status",
        //           name: "projectStatusesFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Start-up Year",
        //           name: "startupYearFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Free Text",
        //           name: "fullTextFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: FEATURE_SWITCHES.FREE_TEXT_FILTER.enabled,
        //           implemented: FEATURE_SWITCHES.FREE_TEXT_FILTER.implemented
        //         },
        //         {
        //           text: "Equipment Types",
        //           name: "equipmentTypeFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Pipelines",
        //           name: "pipelinesFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Power Output (MW)",
        //           name: "powerOutputFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Operators",
        //           name: "operatorsFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           divider: true,
        //           index: filterindex++,
        //           text: "contracting"
        //         },
        //         //{
        //         //  text: "Contractors",
        //         //  name: "contractorsFilter",
        //         //  click: "addFilter(" + filterindex++ + ");",
        //         //  enabled: true,
        //         //  implemented: true
        //         //},
        //         {
        //           text: "Contractors",
        //           name: "contractorsHierachyFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           text: "Contract Stage",
        //           name: "contractStageFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         },
        //         {
        //           divider: true,
        //           index: filterindex++,
        //           text: ""
        //         },
        //         {
        //           text: "Project Created",
        //           name: "projectCreatedDateFilter",
        //           click: "addFilter(" + filterindex++ + ");",
        //           enabled: true,
        //           implemented: true
        //         }
        //       ];

        var operatingCompanyFilterList = [
          {
            text: "Project Name",
            name: "projectNameFilter",
            click: "addFilter(0);",
            enabled: true,
            implemented: false
          },
          {
            text: "Keyphrase",
            name: "keyphraseFilter",
            click: "addFilter(1);",
            enabled: true,
            implemented: false
          }];

        filterindex = 0;
        var contractAwardFilterList = [
          {
            index: filterindex++,
            divider: true,
            text: "contract award"
          },


          //      {
          //        "text": "Contractor Name",
          //        "click": "addContractorNameFilter();",
          //        "enabled": true
          //      },
          {
            index: filterindex++,
            text: "Award Date",
            name: "contractAwardDateFilter"
          },
          {
            index: filterindex++,
            text: "Contractors",
            name: "contractorsHierachyFilter"
          },
          {
            index: filterindex++,
            divider: true,
            text: "contract"
          },
          {
            index: filterindex++,
            text: "Contract Type",
            name: "contractTypeFilter"
          },
          //      {
          //        text:        "Contract Stage",
          //        name:        "contractStageFilter",
          //        click:       "addFilter("  + filterindex++ + ");",
          //        enabled:     true,
          //        implemented: false
          //      },

          //{
          //  text:        "Contract Value",
          //  name:        "dollarValueFilter",
          //  click:       "addFilter("  + filterindex++ + ");",
          //  enabled:     false,
          //  implemented: false
          //},


          //      {
          //        text:        "Keyphrase",
          //        name:        "keyphraseFilter",
          //        click:       "addFilter("  + filterindex++ + ");",
          //        enabled:     true,
          //        implemented: false
          //      },
          {
            divider: true,
            index: filterindex++,
            text: "project"
          },
          {
            index: filterindex++,
            text: "Industry Sector/Project Type",
            name: "industrySectorsFilter"
          },
          {
            index: filterindex++,
            text: "Project Location",
            name: "projectLocationFilter"
          },
          {
            index: filterindex++,
            text: "Operators",
            name: "operatorsFilter"
          }
        ];


        $scope.isProject = function () {
          return projectDataService.isProject;
        };


        $scope.isContract = function () {
          return contractDataService.isContract;
        };

        $scope.hideIcon = "icon-arrow-up";
        $scope.hide = "hide";


        $scope.$watch("showFilterContainer", function () {
          // override the change if looking at a project

          if (projectDataService.isProject) showFilterContainer = false;

          if ($scope.showFilterContainer) {
            $scope.hide = "hide query specification";
            $scope.hideIcon = "icon-arrow-up";
          }
          else {
            $scope.hide = "show query specification";
            $scope.hideIcon = "icon-arrow-down";
          }

        }, true);


        $scope.$watch("contractDataService.isContract", function () {
          // override the change if looking at a project
          if (contractDataService.isContract) {
            $scope.showFilterContainer = false;
            $scope.filtersPinned = false;
          }
        });


        $scope.$watch("projectDataService.isProject", function () {
          // override the change if looking at a project
          if (projectDataService.isProject) {
            $scope.showFilterContainer = false;
            $scope.filtersPinned = false;
          }
        });


        $scope.filtersPinned = false;
        $scope.showFilterContainer = true;
        $scope.loading = searchService.loading;


        $scope.btnNewSearch = function () {
          $scope.removeAllFilters(function () {
            Placeholders.enable();

            if (searchService.queryDef.searchFilters)
              searchService.queryDef.searchFilters.length = 0;

            $scope.selectedFilters.length = 0;
            setGeneralSearchDefaults();

            searchService.queryDef.searchName = '';
            $scope.filtersForm.txtSearchName.$setValidity("notAlreadyInList", true);
            $scope.filtersForm.$setPristine(true);

            $state.go('search');
          });

        };

        var setGeneralSearchDefaults = function () {

          $scope.showFilterContainer = true;

          if (queryBuilderService.addedFilters) queryBuilderService.addedFilters.length = 0;
          if (queryBuilderService.removedFilters) queryBuilderService.removedFilters.length = 0;
          if (searchService.availableFilters) searchService.availableFilters.length = 0;


          $scope.selectedQuery = $scope.nullSavedSearchListItem;
          $scope.searchService.queryDef.clear();
          //$scope.searchService.queryDef = {
          //  searchGuid:    "",
          //  searchName:    "",
          //  sorting:       {sort_desc: false},
          //  paging:        {limit: 20, offset: 0},
          //  criteria:      {},
          //  searchFilters: []
          //};


          queryBuilderService.state.toSelectingSubject();

          searchService.busy = false;

          $scope.filtersForm.$setPristine();


          $scope.$broadcast("NEW_SEARCH");

          //      $scope.$watch("filtersForm.$valid", function () {
          //        if ($scope.filtersForm.$valid)
          //          searchService.getPotentialResultCount();
          //      });

        };


        $scope.btnEdit = function () {
          queryBuilderService.state.toEditing();
        };


        $scope.btnCancel = function () {
          // cancelling an edit only  applies to named and saved searches.
          // state should go back to  displaying and the filters should be
          // reloaded from the server
          var queryDef = savedSearches.get({ guid: searchService.queryDef.guid }, function (q) {
            queryBuilderService.state.toDisplaying();
            $scope.filtersForm.txtSearchName.$setValidity("notAlreadyInList", true);
            searchService.queryDef.apply(queryDef);
          },
            function () {
              showDataErrorMessage("There was an error and the search failed to start");
            }
          );
        };


        $scope.setStartingSearchType = function () {
          // If an initial searchType has been pre-set, simulate
          // the sequence of button presses that result in setting
          // the required searchtype.
          // Each button press handler must be wrapped in a $timeout
          // to make it execute on the next turn. before executing the
          //  search type handler, we must delete the searchType flag
          // to  prevent  later side-effects
          if (searchService.searchType) $scope.btnNewSearch();

          if (searchService.searchType == "project") {
            searchService.searchType = undefined;
            $timeout($scope.newProjectSearch, 0);
          }
          if (searchService.searchType == "contractAward") {
            searchService.searchType = undefined;
            $timeout($scope.newContractAwardSearch, 0);
          }
        };



        $timeout($scope.setStartingSearchType, 0);


      }]);
////------------------------------------------------------------------------

//-------------------------------------------------------------------------
// queryBuilderService\\'WatchList',, WatchList
//-------------------------------------------------------------------------
EICDataStream3QueryBuilder
  .factory('queryBuilderService', ['QueryDefinition', 'searchService',
    function (QueryDefinition, searchService) {
      var queryBuilderService = {};

      queryBuilderService.componentName = "queryBuilderService";
      queryBuilderService.addedFilters = [];
      queryBuilderService.removedFilters = [];


      queryBuilderService.reinstateFilterList = function () {
        // reinstate the list of filters in use
        for (var i = 0; i < searchService.queryDef.searchFilters.length; i++) {
          var thisFilter = searchService.queryDef.searchFilters[i];
          queryBuilderService.addedFilters.push(thisFilter);
        }
      };

      //// This is an example of the way to  push multiple items from a source array
      //queryBuilderService.reinstateFilterList = function() {
      //  Array.prototype.push.apply(queryBuilderService.addedFilters, queryBuilderService.queryDef.searchFilters);
      //};

      //
      queryBuilderService.state = new function () {
        console.log("Query-state initialised to  to: isStarting");

        this.isStarting = true;
        this.isSelectingSubject = false;
        this.isCreating = false;
        this.isDisplaying = false;
        this.isEditing = false;

        this.toSelectingSubject = function () {
          console.log("Query-state changed to: isSelectingSubject");

          this.isStarting = false;
          this.isSelectingSubject = true;
          this.isCreating = false;
          this.isDisplaying = false;
          this.isEditing = false;
        };
        this.toCreating = function () {
          console.log("Query-state changed to: isCreating");

          this.isStarting = false;
          this.isSelectingSubject = false;
          this.isCreating = true;
          this.isDisplaying = false;
          this.isEditing = false;
          searchService.countLoaded = false;
        };
        this.toDisplaying = function () {
          console.log("Query-state changed to: isDisplaying");

          this.isStarting = false;
          this.isSelectingSubject = false;
          this.isCreating = false;
          this.isDisplaying = true;
          this.isEditing = false;
        };
        this.toEditing = function () {
          console.log("Query-state changed to: isEditing");

          this.isStarting = false;
          this.isSelectingSubject = false;
          this.isCreating = false;
          this.isDisplaying = false;
          this.isEditing = true;
          searchService.countLoaded = false;
        };
        this.toStarting = function () {
          console.log("Query-state changed to: isStarting");

          this.isStarting = true;
          this.isSelectingSubject = false;
          this.isCreating = false;
          this.isDisplaying = false;
          this.isEditing = false;
        };
      };





      return queryBuilderService;
    }]);
//-------------------------------------------------------------------------




//-------------------------------------------------------------------------
// Search Service\\'WatchList',, WatchList
//-------------------------------------------------------------------------
EICDataStream3QueryBuilder
  .factory('searchService', ['projectCount', '$http', '$timeout', 'QueryDefinition',
    function (projectCount, $http, $timeout, QueryDefinition) {
      var searchService = {};

      var projectCountCalls = [];

      var inProgress = false;

      searchService.potentialResultsMessage = "";

      searchService.autocompleteOptions = {
        minLength: 2,
        source: "search.aspx",
        delay: 500
      };
      searchService.queryDef = new QueryDefinition();

      // superfluous:  searchService.searchSubject does not seem to be used anywhere
      // searchService.searchSubject = "Project";


      //searchService.watchList = new WatchList();
      //searchService.queryDef = new Object;
      //searchService.queryDef.sorting = {};
      //searchService.queryDef.paging = {};
      //searchService.queryDef.criteria = {};

      //searchService.addedFilters = [];
      //searchService.removedFilters = [];


      //searchService.reinstateFilterList = function () {
      //  // reinstate the list of filters in use
      //  for (var i = 0; i < searchService.queryDef.searchFilters.length; i++) {
      //    var thisFilter = searchService.queryDef.searchFilters[i];
      //    searchService.addedFilters.push(thisFilter);
      //  }
      //};
      ////// This is an example of the way to  push multiple items from a source array
      ////searchService.reinstateFilterList = function() {
      ////  Array.prototype.push.apply(searchService.addedFilters, searchService.queryDef.searchFilters);
      ////};

      var timerPromise;
      searchService.getPotentialResultCount = function () {
        if (!searchService.queryDef) return;

        var success = function (response) {
          let data = response?.data;

          searchService.resultsCount = data.potentialCount;
          searchService.potentialResultsMessage = composePotentialResultsMessage(data);

          searchService.countLoaded = true;
          inProgress = false;
        };

        var failure = function (data, status, headers, config) {
          // called asynchronously if an error occurs
          // or server returns response with an error status.
          searchService.potentialResultsMessage = "data fetch error";
          inProgress = false;
        };


        // Clear the result count message just before sending off for the new result count
        // so that the wrong numbers are not displayed while waiting for an update
        searchService.countLoaded = false;

        // 'Debounce' the projectCount callback so that requests
        // are not stacked up if the form changes very quickly

        projectCountCalls.push(searchService.queryDef);

        if (!timerPromise) {
          timerPromise = $timeout(function () {
            // look at the projectCountCalls list.
            // take and process the last one
            // clear the rest

            if (projectCountCalls.length > 0) {
              var queryDef = projectCountCalls.slice(-1)[0];
              projectCountCalls.length = 0;

              $http.post('/api/projectcount/',
                queryDef,
                { 'Content-Type': 'application/json' })
                .then(success)
                .catch(failure);
            }
            timerPromise = null;

          }, 800);
        }
      };


      var composePotentialResultsMessage = function (countData) {
        var message = ""

        if (countData.error < 0) {
          message = countData.errorMessage;
        }
        else {
          if (countData.potentialCount == 0) {
            message = "This query would not return any {s}{p}"
              .replace("{s}", countData.subject)
              .replace("{p}", countData.potentialCount != 1 ? "s" : "");
          }
          else {
            message = "This query would return {b} {s}{p}"
              .replace("{b}", countData.breakdown)
              .replace("{s}", countData.subject)
              .replace("{p}", countData.potentialCount != 1 ? "s" : "");
          }

        }

        return message;
      };



      return searchService;
    }]);
//-------------------------------------------------------------------------
